import { messageBoxError } from './message-box';

class MaterialComponent {
  private elScope: HTMLElement;

  private el: {
    btAnchors: NodeListOf<HTMLElement>,
    items: NodeListOf<HTMLElement>,
    obItems: NodeListOf<HTMLElement>,
    obMain: HTMLElement,
    cards: NodeListOf<HTMLElement>,
    mainHeader: HTMLElement,
    btLoadMore: NodeListOf<HTMLElement>,
    btLoadLess: NodeListOf<HTMLElement>,
  };

  private className = {
    isActive: 'is-active',
    isAdded: 'is-added',
    isFull: 'is-full',
    isVisible: 'is-visible',

    hasInactiveSubitems: 'has-inactive-subitems',
  };

  private itemsAdded = 0;

  private maxItems = 6;

  private errorMessage: string;

  constructor(elScope: HTMLElement, maxItems: number) {
    this.maxItems = maxItems;
    this.elScope = elScope;
    this.init();
  }

  private cache(): void {
    this.el = {
      btAnchors: this.elScope.querySelectorAll('.js-o-mtr__bt-anchor'),
      items: this.elScope.querySelectorAll('.js-o-mtr__item'),
      obItems: this.elScope.querySelectorAll('.js-o-mtr__ob'),
      obMain: this.elScope.querySelector('.js-o-mtr__main-obj') as HTMLElement,
      cards: this.elScope.querySelectorAll('.js-m-post-card[data-id]'),
      btLoadMore: this.elScope.querySelectorAll('.js-o-mtr__bt-more'),
      btLoadLess: this.elScope.querySelectorAll('.js-o-mtr__bt-less'),

      mainHeader: document.querySelector('#js-l-header') as HTMLElement,
    };

    this.errorMessage = this.elScope.dataset.error || 'Thank you, but you only can add 6 pieces to your list.';;
  }

  private bindings(): void {
    const { el } = this;

    el.btAnchors.forEach((elBt, index) => elBt.addEventListener('click', () => this.scrollToTargetByIndex(index)));

    el.items.forEach((elItem) => {
      const elButton = elItem.querySelector('.js-o-mtr__item-h') as HTMLElement;
      elButton.addEventListener('click', () => this.handlerToggleItemAccordion(elItem));
    });

    el.obItems.forEach((elObItem, index) => {
      elObItem.addEventListener('visibility-changed', ({detail}: any) => this.handlerObItemVisibilityChanged(detail, index));
    });

    el.obMain.addEventListener('visibility-changed', (e: any) => this.handlerComponentVisibility(e));

    el.cards.forEach((elCard) => {
      const elBtAdd = elCard.querySelector('.js-m-post-card__add') as HTMLElement;
      elBtAdd?.addEventListener('click', () => this.handlerCardUpdate(elCard));
    });

    el.btLoadMore.forEach((elButton) => {
      elButton.addEventListener('click', () => this.toggleLoadMore(elButton, true));
    });

    el.btLoadLess.forEach((elButton) => {
      elButton.addEventListener('click', () => this.toggleLoadMore(elButton, false));
    });

    document.addEventListener('form-materials:ids-updated', (e:any) => this.handlerIdsUpdated(e.detail.ids));
    document.addEventListener('materials-bar:request-remove', (e:any) => this.handlerRemove(e.detail.id));
  }

  private toggleLoadMore(elButton: HTMLElement, isMore: boolean = true): void {

    const target = elButton.dataset.target || '';
    const elTarget = document.querySelector(target);
    this.toggleSubitems(elTarget, !isMore);
  }

  private handlerCardUpdate(elCard: HTMLElement): void {
    const { className } = this;

    const isAdded = elCard.classList.contains(className.isAdded);
    const eventInstruction = isAdded ? 'remove' : 'add';
    // if should be removed
    // or should be added but is not fill
    if (eventInstruction === 'remove' || (this.getIsFull() === false && eventInstruction === 'add')) {
      const id = Number(elCard.dataset.id) || -1;
      document.dispatchEvent(new CustomEvent(`materials:${eventInstruction}`, {
        detail: { id },
      } as any));
    } else if (eventInstruction === 'add' || (this.getIsFull() === true )) {
      messageBoxError({
        contentDe: 'Bereits 6 Samples ausgewählt.',
        contentEn: 'Already 6 samples selected.',
      });
    }
  }

  private handlerRemove(id: number) {
    const { el } = this;

    const elCard = Array.from(el.cards).find((elCard) => Number(elCard.dataset.id) === id);
    elCard?.querySelector('.js-m-post-card__add')?.dispatchEvent(new Event('click'));
  }

  private handlerIdsUpdated(ids: number[]): void {
    const { elScope, el, className } = this;

    // First clean all
    el.cards.forEach((elCard) => {
      elCard.classList.remove(className.isAdded);
    });
    this.itemsAdded = 0;

    // Then just active the new ids
    ids.forEach((id) => {
      const elCardMatch = Array.from(el.cards).find((elCard: HTMLElement) => {
        return Number(elCard.dataset.id) === id;
      });
      if (elCardMatch && !this.getIsFull()) {
        elCardMatch.classList.add(className.isAdded);
        this.itemsAdded = this.itemsAdded + 1;
      }
    });

    document.dispatchEvent(new Event('materials:ui-updated'));
    const isMaxItemsReached = this.getIsFull();
    elScope.classList.toggle(className.isFull, isMaxItemsReached);
  }

  private toggleSubitems(elSubitems: Element | null, isToggle: boolean) {
    const { className } = this;

    elSubitems?.classList.toggle(className.hasInactiveSubitems, isToggle);
  }

  private getIsFull(): boolean {
    return this.itemsAdded >= this.maxItems;
  }

  private scrollToTargetByIndex(index: number): void {
    const { el } = this;

    const elTarget = el.items[index];
    const offsetY = el.mainHeader.clientHeight * 2; //height navigation
    window.scrollTo({
      top: elTarget.getBoundingClientRect().top + window.scrollY - offsetY,
      left: 0,
      behavior: 'smooth',
    });
  }

  private handlerToggleItemAccordion(el: HTMLElement): void {
    const { className } = this;

    const elSubitems = el.querySelector('.js-o-mtr__item-s');
    el.classList.toggle(className.isActive);
    this.toggleSubitems(elSubitems, true)
  }

  private handlerObItemVisibilityChanged(detail: {visible: boolean}, index: number): void {
    const { el, className } = this;
    if (detail.visible) {
      el.btAnchors.forEach((elAnchor) => {
        elAnchor.classList.remove(className.isActive);
      });
      el.btAnchors[index].classList.add(className.isActive);
    }
  }

  private handlerComponentVisibility(e: any) {
    // console.log(e)
    const { elScope, className } = this;
    // const isVisibleOrBelowFold =
    //   (e.detail.visible === true) ||
    //   (e.detail.visible === false && e.currentTarget.getBoundingClientRect().top < 0);

    elScope.classList.toggle(className.isVisible, e.detail.visible);

    if (e.detail.visible === true) {
      elScope.querySelector('.o-mtr__footer')?.classList.add(className.isVisible);
    }
  }

  private init(): void {
    this.cache();
    this.bindings();
  }
}

class MaterialBarComponent {

  private elScope: HTMLElement;

  private el: {
    moduleMaterials: HTMLElement,
    btThumbsToggle: HTMLElement,
    btThumbsClose: HTMLElement,
    total: HTMLElement,
    items: NodeListOf<HTMLElement>,
  };

  private status = {
    SHOW_THUMBS: 'show-thumbs',
    NORMAL: '',
  };

  private isVisible: boolean = false;

  private maxItems = 6;

  private storage_name = 'val-materials-v1.2.0';

  constructor(elScope: HTMLElement, maxitems: number) {
    this.elScope = elScope;
    this.maxItems = maxitems;
    this.cacheElements();
    this.updateUiMaterial();
    this.bindings();
  }

  private cacheElements() {
    this.el = {
      moduleMaterials: document.querySelector('.js-o-mtr') as HTMLElement,
      btThumbsToggle: this.elScope.querySelector('.js-o-mtr__th-bt-toggle') as HTMLElement,
      btThumbsClose: this.elScope.querySelector('.js-o-mtr__th-bt-close') as HTMLElement,
      total: this.elScope.querySelector('.js-o-mtr__th-tot') as HTMLElement,
      items: this.elScope.querySelectorAll('.js-o-mtr__th-item') as NodeListOf<HTMLElement>,
    };
  }

  private getInitialIds() {
    const { storage_name } = this;
    const ids = window.sessionStorage.getItem(storage_name);

    try {
      return ids ? JSON.parse(ids) : [];
    } catch(e) {
      console.error(e);
      return [];
    }
  }

  private updateUiMaterial() {
    const { el, maxItems } = this;

    // Remove all Thumbs
    el.items.forEach((elLocationThumb) => {
      const elThumb = elLocationThumb.querySelector('.js-o-mtr__th-item-r');
      if (elThumb) {
        elThumb.remove();
      }
    });

    const idsAdded = this.getInitialIds();
    idsAdded.forEach((idAdded: any, index: number) => {
      const elPostCard = el.moduleMaterials?.querySelector(`.js-m-post-card.is-added[data-id="${idAdded}"]`);

      // Add Thumbs
      if (elPostCard) {
        const elLocationThumb = el.items[index];

        if (index + 1 <= maxItems && elLocationThumb) {
          const id = elPostCard.getAttribute('data-id');
          const title = elPostCard.querySelector('.js-m-post-card__title')?.innerHTML || 'title not found';
          const desc = elPostCard.querySelector('.js-m-post-card__desc')?.innerHTML || 'title not found';
          const elImage = elPostCard.querySelector('.js-m-post-card__image') as HTMLImageElement;
          let srcImage = '' as String;
          if (elImage) {
            if (elImage.dataset.src != '') {
              srcImage = elImage.dataset.src as String;
            }
            else {
              srcImage = elImage.src;
            }
          }
          const htmlCard = `
            <button class='o-mtr__th-item-r js-o-mtr__th-item-r' aria-label='Remove' data-id='${id}'>
              <div class='o-mtr__th-item-p'>
                <span class='o-mtr__th-item-p-i' style='background-image:url(${srcImage})'></span>
                <h3 class='o-mtr__th-item-p-t'>${title}</h3>
                <h4 class='o-mtr__th-item-p-d'>${desc}</h4>
              </div>
              <span class='o-mtr__th-item-bg' style='background-image:url(${srcImage})'></span>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" = viewBox="0 0 41.586 41.586" >
                <g>
                  <line fill="none" stroke="#231F20" stroke-width="0.5" stroke-miterlimit="10" x1="41.409" y1="0.177" x2="0.178" y2="41.409"></line>
                  <line fill="none" stroke="#231F20" stroke-width="0.5" stroke-miterlimit="10" x1="0.177" y1="0.177" x2="41.408" y2="41.409"></line>
                </g>
              </svg>
            </button>
          `;
          elLocationThumb.innerHTML += htmlCard;
        }
      }
    });

    // Add Listener (on click thumb added)
    const elThumbs = el.moduleMaterials.querySelectorAll('.js-o-mtr__th-item-r');
    elThumbs.forEach((elThumb) => {
      elThumb.addEventListener('click', () => this.requestRemoveById(Number((elThumb as HTMLElement).dataset.id)));
    });

    // Update totals
    el.total.innerHTML = `${elThumbs.length}`;
  }

  private requestRemoveById(id: number) {
    document.dispatchEvent(
      new CustomEvent('materials-bar:request-remove', {
        detail: { id },
      } as any)
    );
  }

  private bindings() {
    const { el } = this;
    document.addEventListener('materials:ui-updated', () => this.updateUiMaterial());

    el.btThumbsToggle.addEventListener('click', () => this.toggleList());
    el.btThumbsClose.addEventListener('click', () => this.toggleList(false));
  }

  private toggleList(isVisible?: boolean) {
    const { elScope, status } = this;

    this.isVisible = isVisible != undefined ? isVisible : !this.isVisible;
    elScope.dataset.status = this.isVisible ? status.SHOW_THUMBS : status.NORMAL;
  }
}

export default class Materials {
  init() {
    const MAXITEMS = 6;

    document.querySelectorAll('.js-o-mtr').forEach((el) => {
      new MaterialComponent(el as HTMLElement, MAXITEMS);
      new MaterialBarComponent(el as HTMLElement, MAXITEMS);
    });
  }
}
